export const setAffectationMntRetenuALaSourceCli = (value) => {
  return (dispatch) => {
    dispatch({ type: "AFF_MNT_RETENU_CLI", payload: value });
  };
};
